export default {
  dataIterator: {
    rowsPerPageText: 'Itens por página:',
    rowsPerPageAll: 'Todos',
    pageText: '{0}-{1} de {2}',
    noResultsText: 'Nenhum dado encontrado',
    nextPage: 'Próxima página',
    prevPage: 'Página anterior'
  },
  dataTable: {
    rowsPerPageText: 'Linhas por página:'
  },
  noDataText: 'Não há dados disponíveis'
}
